<template>
  <div class="logins">
    <div class="wrap" @click="hide($event)">
      <!-- 上面的头部 -->
      <div class="header clearfix">
        <div class="logo fl">
          <img src="../assets/image/login/login-logo-top.png" alt="" />
        </div>
        <p class="title fl bold">农业物联网通用平台</p>

        <span
          class="control fr pointer noselect"
          @click="showDownLoad = !showDownLoad"
        >
          控件下载
          <i :class="showDownLoad ? 'rotate180' : ''"></i>
        </span>
        <section
          class="download flex flex_col flex_ju_c animate__animated"
          v-show="showDownLoad"
          :class="showDownLoad ? 'animate__fadeIn' : 'animate__fadeOut'"
        >
          <span class="pointer">
            <a
              style="font-size: 0.2rem"
              href="http://222.133.14.246:18085/hnyfkj-file-server/plugins/app/vlc-3.0.14-win32.exe"
              >vlc控件</a
            >
          </span>
          <!-- <span class="pointer">数据控件</span> -->
        </section>
      </div>
      <!-- 中间区域 -->
      <div class="main flex flex_a_end flex_ju_c">
        <div class="banner">
          <el-carousel trigger="click" :autoplay="true" arrow="never">
            <el-carousel-item v-for="item in bannerArr" :key="item.src">
              <img :src="item.src" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="user-login">
          <div class="tabs flex">
            <div
              class="flex flex_a_c flex_ju_c"
              v-for="(tab, i) in tabsArr"
              :key="i"
            >
              <!-- <el-image :src="i === index ? tab.activeImg : tab.deactiveImg" lazy></el-image> -->
              <img :src="i === index ? tab.activeImg : tab.deactiveImg" />
              <span
                class="pointer"
                :class="i === index ? 'active' : ''"
                @click="index = i"
              >
                {{ tab.text }}
              </span>
            </div>
          </div>

          <div class="spilt"></div>

          <div class="content">
            <!-- 表单 -->
            <div v-if="index === 0" class="account">
              <h3>账号登录</h3>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                class="demo-ruleForm"
              >
                <el-form-item prop="loginName">
                  <el-input
                    type="text"
                    v-model="ruleForm.loginName"
                    autocomplete="off"
                    placeholder="请输入用户名"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    type="password"
                    v-model="ruleForm.password"
                    autocomplete="off"
                    placeholder="请输入密码"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="code" class="qr-code" v-if="isYanZheng">
                  <el-input
                    type="text"
                    v-model="ruleForm.code"
                    placeholder="请输入验证码"
                  ></el-input>
                  <!-- 验证码 -->
                  <canval-code
                    ref="checkCodeModal"
                    class="code"
                    @codeUpdata="codeUpdata"
                  ></canval-code>
                </el-form-item>
                <el-form-item>
                  <el-checkbox
                    v-model="ruleForm.remember"
                    label="记住账号和密码"
                    class="checkoutname"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-button
                    class="login-btn"
                    v-loading="isLoading"
                    type="primary"
                    :class="{ active: isCanTap }"
                    @click="onSubmit('ruleForm')"
                    >登录</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <!-- app下载 -->
            <div v-if="index === 1" class="APP">
              <h3>扫描二维码下载APP</h3>
              <div class="qr-code flex">
                <img src="@/assets/image/login/yunpengCode.png" alt="" />
              </div>
              <div class="description">元丰云棚APP二维码</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部图标和名称 -->
      <div class="footer">
        <ul class="flex flex_ju_sb">
          <li
            class="categories flex flex_col flex_a_c"
            v-for="cate of footer_categories"
            :key="cate.title"
          >
            <div class="flex flex_a_c flex_ju_c img-div">
              <img :src="cate.imgSrc" alt="" />
            </div>

            <span>{{ cate.title }}</span>
          </li>
        </ul>
        <div class="footnote">
          <span>© &nbsp;2015-2025河南元丰科技网络股份有限公司版权所有</span>
          <img src="@/assets/image/login/logo-bottpm.png" alt="" />
          <div class="bah">
            备案号：
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              >豫B2-20150097-4</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CanvalCode from "@/components/CanvalCode.vue";
/**
 * @description 登陆页面
 */
export default {
  name: "Login",
  data() {
    // 验证码
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      } else {
        if (value.toLowerCase() != this.checkCode.toLowerCase()) {
          this.$refs.checkCodeModal.refreshCode();
          return callback(new Error("验证码输入错误"));
        }
        callback();
      }
    };
    var validateAccount = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
      // else {
      //   if (this.ruleForm.password !== '') {
      //     this.$refs.ruleForm.validateField('password');
      //   }
      //   callback();
      // }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
      // else if (value !== this.ruleForm.pass) {
      //   callback(new Error('两次输入密码不一致!'));
      // } else {
      //   callback();
      // }
    };

    return {
      showDownLoad: false,

      // tab切换
      tabsArr: [
        {
          text: "用户登录",
          activeImg: require("@/assets/image/login/avatar.png"),
          deactiveImg: require("@/assets/image/login/deactive-avatar.png"),
        },
        {
          text: "APP下载",
          activeImg: require("@/assets/image/login/download.png"),
          deactiveImg: require("@/assets/image/login/deactive-download.png"),
        },
      ],
      // 轮播数据
      bannerArr: [
        { src: require("@/assets/image/login/banner1.png") },
        { src: require("@/assets/image/login/banner2.png") },
        { src: require("@/assets/image/login/banner3.png") },
      ],
      index: 0,
      // 表单数据
      ruleForm: {
        loginName: "",
        password: "",
        code: "",
        remember: "",
      },
      // 表单校验
      rules: {
        // account: [{ validator: validateAccount, trigger: 'blur' }],
        // password: [{ validator: validatePass, trigger: 'blur' }],
        // code: [{ validator: checkAge, trigger: 'blur' }],
        loginName: [
          { required: true, trigger: "blur", message: "请输入用户名" },
        ],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
        code: [{ trigger: "blur", validator: checkAge }],
        // code: [{ trigger: 'blur' }],
      },
      isLoading: false,
      isCanTap: false, // 按钮是否可点击
      wrongNumber: 0, //輸入次數
      // 下面的类别
      footer_categories: [
        { title: "温室大棚", imgSrc: require("@/assets/image/login/peng.png") },
        { title: "畜牧养殖", imgSrc: require("@/assets/image/login/niu.png") },
        { title: "水产渔业", imgSrc: require("@/assets/image/login/shui.png") },
        { title: "大田种植", imgSrc: require("@/assets/image/login/tian.png") },
      ],
      checkCode: "", // 自己绘制出来的验证码
    };
  },
  components: { CanvalCode },
  created() {
    this.keyupSubmit();
  },
  computed: {
    isYanZheng() {
      if (this.wrongNumber >= 3) {
        this.isCanTap = false;
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    // 如果是记住账号密码，则页面进入的时候就获取缓存，进行赋值
    let isRemember = window.localStorage.getItem("wlwisRemember");

    if (isRemember) {
      let names = window.localStorage.getItem("wlwname");
      let pass = window.localStorage.getItem("wlwpass");
      this.$set(this.ruleForm, "loginName", names);
      this.$set(this.ruleForm, "password", pass);
    }
  },
  methods: {
    keyupSubmit() {
      document.onkeydown = (e) => {
        let _key = window.event.keyCode;
        //!this.clickState是防止用户重复点击回车
        if (_key === 13 && this.isCanTap) {
          this.onSubmit("ruleForm");
        }
      };
    },
    // 页面点击隐藏控件下载的下拉框
    hide(e) {
      const res = e.path.some((s) => {
        const name = s.className || "";
        return (name && name.includes("control")) || name.includes("download");
      });
      if (!res) {
        // 点击的不是控件下载, 隐藏掉
        if (this.showDownLoad) this.showDownLoad = false;
      }
    },
    // 点击登陆
    onSubmit(formName) {
      console.log(123);
      if (this.isLoading) return;
      this.$refs[formName].validate((valid) => {
        console.log(valid);
        if (valid) {
          // 加载中
          this.isLoading = true;
          this.makeLogin();
        } else {
          return false;
        }
      });
    },
    // 登录请求
    async makeLogin() {
      let params = {
        loginName: this.ruleForm.loginName,
        password: this.ruleForm.password,
        // imageCode: this.ruleForm.code,
      };
      if (this.isYanZheng) {
        params.imageCode = this.ruleForm.code;
      }
      await this.$http
        .postAction(this.$api.apiLogin, params)
        .then((res) => {
          if (res.meta.success) {
            let datas = res.data;
            // 存储token值，用作是都已登陆的判断
            window.localStorage.setItem("wlwtoken", datas.token);
            if (datas.user) {
              window.localStorage.setItem(
                "wlwUser",
                JSON.stringify(datas.user)
              );
            }
            if (datas.userInfo) {
              window.localStorage.setItem(
                "wlwUserInfo",
                JSON.stringify(datas.userInfo)
              );
            }

            if (datas.org) {
              window.localStorage.setItem("wlwOrg", JSON.stringify(datas.org));
            }
            window.localStorage.setItem("wlwuserName", this.ruleForm.loginName);
            // 存储记住账号和密码
            if (this.ruleForm.remember) {
              window.localStorage.setItem("wlwisRemember", true);
              window.localStorage.setItem("wlwname", this.ruleForm.loginName);
              window.localStorage.setItem("wlwpass", this.ruleForm.password);
            } else {
              window.localStorage.removeItem("wlwisRemember");
              window.localStorage.removeItem("wlwname");
              window.localStorage.removeItem("wlwpass");
            }
            setTimeout(() => {
              this.isLoading = false;
              this.$router.push("/home");
            }, 1000);
          } else {
            this.isLoading = false;
            this.wrongNumber++;
            this.$message(res.meta.message, "error");
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.$message("服务出错，请稍后重试", "error");
        });
    },
    // 验证码变化
    codeUpdata(val) {
      this.checkCode = val;
    },
  },
  watch: {
    ruleForm: {
      deep: true,
      handler(val) {
        // console.log(val)
        console.log(this.isYanZheng);
        if (this.isYanZheng) {
          if (val.loginName !== "" && val.password !== "" && val.code !== "") {
            this.isCanTap = true;
          } else {
            this.isCanTap = false;
          }
        } else {
          if (val.loginName !== "" && val.password !== "") {
            this.isCanTap = true;
          } else {
            this.isCanTap = false;
          }
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
$bacc: 100% 100%;
.logins {
  width: 100%;
  height: 100%;
  min-height: 100%;

  .wrap {
    width: 100%;
    min-height: 100%;
    background: url("../assets/image/login/login-bacc.png") no-repeat;
    background-size: $bacc;
  }

  .header {
    height: 0.97rem;
    padding: 0 0.3375rem 0 1.0625rem;
    background-color: #fff;

    .logo {
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: 2.125rem;
        height: 0.625rem;
      }
    }
    .title {
      padding-left: 69px;
      font-size: 0.4rem;
      line-height: 0.975rem;
      font-family: "DFPZongYiW7-GB";
      color: #2daea9;
    }
    .control {
      position: relative;
      font-size: 0.2rem;
      // font-family: 'Source Han Sans CN';
      line-height: 0.975rem;
      color: #262727;
      i {
        width: 0;
        height: 0;
        display: inline-block;
        margin-left: 0.225rem;
        border-top: 0.12rem solid #d7d7d7;
        border-left: 0.08rem solid transparent;
        border-right: 0.08rem solid transparent;
      }
    }
    .download {
      position: absolute;
      top: 0.9rem;
      right: 0;
      width: 1.8625rem;
      // height: 1.075rem;
      padding: 0.25rem 0;
      background: #ffffff;

      span {
        // height: 0.2rem;
        padding-left: 0.35rem;
        font-size: 0.2rem;
        // font-family: 'Source Han Sans CN';
        font-weight: 400;
        border-left: 0.025rem solid transparent;
      }
      span:hover {
        color: #2daea9;
        border-left: 0.025rem solid #2daea9;
      }
      span + span {
        margin-top: 0.19rem;
      }
    }
  }

  .main {
    width: 100%;
    // height: 8.125rem;
    // height: 7.22rem;
    padding-top: 4vh;
    .banner {
      width: 9rem;
      // height: 5.88rem;
      height: 51.3vh;
      img {
        width: 9rem;
        height: 100%;
      }

      ::v-deep .el-carousel__button {
        width: 10px;
        height: 10px;
        background: #c1c1c1;
        border-radius: 50%;
      }

      ::v-deep .el-carousel__indicator.is-active button {
        background: #2daea9;
      }
      ::v-deep .el-carousel__indicator + .el-carousel__indicator {
        margin-left: 0.625rem;
      }
    }

    .user-login {
      width: 5.88rem;
      // height: 6.75rem;
      height: 59vh;
      min-height: 360px;
      margin-left: 0.96rem;
      background: #ffffff;
      box-shadow: 0px 1px 16px 0px rgba(233, 238, 244, 0.38);
      border-radius: 6px;
      // padding-bottom: 1.3rem;

      .tabs > div {
        width: 50%;
        height: 0.85rem;

        img {
          width: 0.25rem;
          height: 0.25rem;
        }
        span {
          height: 100%;
          margin-left: 0.175rem;
          line-height: 0.85rem;
          font-size: 0.25rem;
          // font-family: 'Source Han Sans CN';
          color: #979797;
        }
        span.active {
          color: #2daea9;
          border-bottom: 3px solid #2daea9;
        }
      }
      .spilt {
        height: 1px;
        background: #e1e3e8;
      }

      h3 {
        margin-top: 0.5625rem;
        margin-bottom: 0.375rem;
        text-align: center;
        font-size: 0.3rem;
        // font-family: 'Source Han Sans CN';
        font-weight: 400;
        color: #2daea9;
      }

      .account {
        width: 4.15rem;
        margin: 0 auto;
        & ::v-deep .el-form-item {
          margin-bottom: 0.25rem;
        }
        & ::v-deep .el-input__inner {
          height: 0.6rem;
        }
        & ::v-deep .el-input__inner::placeholder {
          font-size: 0.225rem;
          color: #e2e2e2;
        }
        .login-btn {
          width: 100%;
          height: 0.6rem;
          background: #069f99;
          border-radius: 4px;
          opacity: 0.5;
          border: none;
        }
        .active {
          opacity: 1;
        }
        .qr-code {
          .el-input {
            width: 1.85rem;
          }
          .code {
            position: absolute;
            width: 1.69rem;
            height: 0.63rem;
            right: 0;
            top: 0;
            // background-color: red;
          }
        }
        .checkoutname {
          color: #e2e2e2;
          font-size: 0.23rem;
          .el-checkbox__input.is-checked .el-checkbox__inner {
            border-color: #66a3a1;
            background-color: transparent;
          }
        }
      }

      .APP {
        .qr-code {
          width: 3.25rem;
          height: 3.25rem;
          margin: 0 auto;
          background: url("../assets/image/login/QR-code-bacc.png") no-repeat;
          background-size: $bacc;
          img {
            width: 3.15rem;
            height: 3.05rem;
            margin: auto;
          }
        }
        .description {
          margin-top: 0.25rem;
          text-align: center;
          font-size: 0.225rem;
          // font-family: 'Source Han Sans CN';
          color: #2daea9;
        }
      }
    }
  }

  .footer {
    // margin-top: 0.6rem;
    margin-top: 5.2vh;
    // margin-bottom: .225rem;
    // height: 330px;
    // background-color: red;
    ul {
      width: 9.5rem;
      margin: 0 auto;
    }
    .categories {
      .img-div {
        width: 7.4vh;
        // height: 0.85rem;
        height: 7.4vh;
        // margin-bottom: 0.21rem;
        margin-bottom: 1.8vh;
        border: 2px solid #2daea9;
        border-radius: 50%;
      }
      img {
        width: 5vh;
        // height: 0.57rem;
        height: 5vh;
      }
      span {
        font-size: 0.25rem;
        color: #2daea9;
      }
    }
    .footnote {
      text-align: center;
      // padding-bottom: 0.225rem;
      //   padding-bottom: 1.96vh;
      // margin-top: 0.5rem;
      margin-top: 4.3vh;
      span {
        font-family: "Source Han Sans CN";
        font-size: 0.2rem;
        color: #262727;
        padding-top: 0.06rem;
      }
      img {
        width: 1.0875rem;
        margin-left: 0.1625rem;
        vertical-align: bottom;
      }
      .bah {
        // margin-top: 0.1875rem;
        margin-top: 0.125rem;
        font-size: 0.2rem;
        a {
          font-size: 0.2rem;
          color: #2daea9;
        }
        a:hover {
          color: #2daea9;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.checkoutname {
  color: #e2e2e2;
  font-size: 0.23rem;
  .el-checkbox__input {
    outline: none;
    &.is-checked {
      .el-checkbox__inner {
        border-color: #66a3a1;
        background-color: transparent;
        &::after {
          border-color: #069f99;
        }
      }
    }
  }

  &.is-checked {
    .el-checkbox__label {
      font-size: 14px !important;
      color: #4e4e4e !important;
    }
  }
}
.login-btn {
  span {
    font-size: 0.25rem !important;
  }
}
.logins {
  .el-carousel {
    height: 100%;
  }
  .el-carousel__container {
    height: 100%;
  }
}
</style>
